/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosInstance } from '../axios.ts';
import { PaginatedResponse, RequestParameters } from '../types';
import { getForcedPaginatedEndpoint } from '../utils.ts';
import { INotification } from './types.ts';

export async function getAgreementNotifications(params: RequestParameters): Promise<PaginatedResponse<INotification>> {
  return getForcedPaginatedEndpoint(`/agreement_staff/notifications_emails/`, params);
}

export async function deleteAgreementNotifications(notificationId: number): Promise<PaginatedResponse<INotification>> {
  return axiosInstance.delete(`/agreement_staff/notifications_emails/${notificationId}/`);
}

export async function createAgreementNotifications(data: INotification) {
  if (data.fileEmails) {
    const newformData = new FormData();
    newformData.append('file_emails', data.fileEmails);
    newformData.append('email_title', data.emailTitle);
    newformData.append('email_body', data.notificationType === 'email' ? data.html : data.emailBody);
    newformData.append('email_subject', data.emailSubject);
    if (data.date.length) newformData.append('date', data.date);
    newformData.append('time', data.time);
    if (data.type) newformData.append('schedule_type', data.type);
    if (data.daysOfWeek) {
      for (let i = 0; i < data.daysOfWeek.length; i++) {
        newformData.append(`days_of_week[${i}]`, data.daysOfWeek[i]);
      }
    }
    newformData.append('notification_type', data.notificationType);
    if (data.discount) newformData.append('discount', String(data.discount));

    if (data.agreement) newformData.append('agreement', String(data.agreement));

    return axiosInstance.post(`/agreement_staff/notifications_emails/`, newformData);
  }

  return axiosInstance.post(`/agreement_staff/notifications_emails/`, toNotificationPayload(data));
}

function toNotificationPayload(data: INotification) {
  return {
    send_to: data.sendTo,
    emails: data.emailsList,
    email_title: data.emailTitle,
    email_body: data.notificationType === 'email' ? data.html : data.emailBody,
    email_subject: data.emailSubject,
    push_body: data.pushBody,
    push_subject: data.pushSubject,
    date: data.date.length ? data.date : undefined,
    time: data.time,
    schedule_type: data.type,
    days_of_week: data.daysOfWeek,
    notification_type: data.notificationType,
    discount: data.discount,
    agreement: data.agreement,
    users: data.users,
  };
}

export interface ITestNotificationResponse {
  sent_to?: string;
  dry_run?: boolean;
}

/** Não dispara para os destinatários: e-mail vai só para testEmail (padrão: e-mail do usuário logado);
 * push é validado no Firebase em dry run. Nada é salvo. */
export async function testAgreementNotification(data: INotification, testEmail?: string) {
  return axiosInstance.post<ITestNotificationResponse>(`/agreement_staff/notifications_emails/test/`, {
    ...toNotificationPayload(data),
    // com CSV o envio real usa o arquivo; para o teste basta o conteúdo
    send_to: data.fileEmails ? 'manual-list' : data.sendTo,
    test_email: testEmail || undefined,
  });
}

interface UploadIMageResponse {
  file: string;
}

export async function uploadEmailImage(blobInfo: any) {
  const formData = new FormData();
  formData.append('file', blobInfo.blob(), blobInfo.filename());
  return axiosInstance.post<UploadIMageResponse>(`/agreement_staff/email/upload_image/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
